module.exports = __webpack_public_path__ + "static/media/404-no.0ec9cb01.png";